import { Box, Switch, Tooltip } from "@material-ui/core";

import { Detail } from "~/components/typography/detail";
import { InlineIconButton } from "~/icons/inlineIconButton";
import React from "react";
import { SettingItemProps } from "~/components/appSettings/menu";
import { useTranslation } from "react-i18next";

const VendorRevenueMetricOption: React.FC<SettingItemProps> = ({
  title,
  tooltip,
  checked,
  setChecked,
  colour,
}) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Detail>{title}</Detail>
        <Tooltip title={tooltip}>
          <InlineIconButton />
        </Tooltip>
      </Box>
      <Box display="flex" alignItems="center">
        <Switch
          size="small"
          color={colour ?? "secondary"}
          checked={checked}
          onClick={() => setChecked(!checked)}
        />
        <Detail>
          {t(
            checked
              ? "shippedRevenue.revenueOption"
              : "orderedRevenue.revenueOption"
          )}
        </Detail>
      </Box>
    </Box>
  );
};

export default VendorRevenueMetricOption;
